var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PublicMenuLayoutV2", {
    attrs: { invertedColorsMobile: "" },
    scopedSlots: _vm._u([
      {
        key: "nav-items",
        fn: function() {
          return [
            _c(
              "b-nav-item",
              {
                staticClass: "my-auto",
                on: {
                  click: function() {
                    _vm.$helpers.goToProfessionalsLanding()
                  }
                }
              },
              [_c("p", [_vm._v(_vm._s(_vm.$t("professionals")))])]
            ),
            _vm._v(" "),
            _c(
              "b-nav-item",
              [
                _c(
                  "router-link",
                  { attrs: { to: "/opensalud360/empresas", tag: "p" } },
                  [_vm._v(_vm._s(_vm.$t("patients-layout.companies")))]
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "nav-btn-items",
        fn: function() {
          return [
            _c(
              "b-nav-item",
              { staticClass: "my-auto d-block ml-0 ml-xl-2" },
              [
                _c(
                  "router-link",
                  { attrs: { to: "/inicio-sesion" } },
                  [
                    _c("ArrowButton", {
                      attrs: {
                        text: _vm.$t("login-wrd"),
                        action: function() {
                          _vm.$router.push("/inicio-sesion")
                        },
                        reverse: "",
                        backgroundColor: _vm.BLUE_COLOUR,
                        textColor: _vm.WHITE_COLOUR
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-391540ff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-391540ff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/OpensaludPacientesLayout.vue
// module id = 2037
// module chunks = 116